import { SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, OnInit, signal } from '@angular/core';

import { Phone } from '@app/entities/interfaces/ptrab/shared/phone.interface';
import { TwoFactorOperationCode } from '@app/entities/interfaces/ptrab/two-factor-authorization.interface';
import { PhoneSelectionDialogData } from '@app/entities/interfaces/ptrab/two-factor-dialog-data.interface';
import { Buttons } from '@app/entities/models/buttons/buttons';
import { ModalManager } from '@app/services';

import { M_DIALOG_DATA } from '@mercadona/components-musi/dialog';
import { MRadioButtonComponent, MRadioGroupComponent } from '@mercadona/components-musi/radio-button';
import { MTranslatePipe } from '@mercadona/core/translate';

import { PtrabTwoFactorCardComponent } from '../../two-factor-card/two-factor-card.component';

@Component({
  selector: 'app-ptrab-second-fa-phone-selection',
  imports: [SlicePipe, MTranslatePipe, PtrabTwoFactorCardComponent, MRadioGroupComponent, MRadioButtonComponent],
  templateUrl: './second-fa-phone-selection.component.html',
  styleUrls: ['./second-fa-phone-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SecondFaPhoneSelectionComponent implements OnInit {
  readonly #data: PhoneSelectionDialogData = inject(M_DIALOG_DATA);
  readonly #modalManager = inject(ModalManager);

  readonly reminderMessage = 'TWO_FACTOR.VERIFY_PHONE.REMEMBER';

  readonly phones = signal<Phone[]>([]);
  readonly selectedPhoneId = signal<string | null | undefined>(undefined);
  readonly availablePhones = computed<Phone[]>(() => this.phones().filter((phone) => phone.sms));
  readonly isSinglePhone = computed<boolean>(() => this.availablePhones().length === 1);
  readonly uniquePhone = computed<Phone | undefined>(() => this.availablePhones()[0]);

  readonly buttons = computed<Buttons[]>(() => [
    {
      text: 'TWO_FACTOR.VERIFY_NUMBER.NO_PHONE',
      type: 'ghost',
      enabled: true,
      onClick: () => this.#modalManager.dismissMatModal(TwoFactorOperationCode.REQUEST_OTHER_PHONE)
    },
    {
      text: 'COMMON.NEXT',
      enabled: Boolean(this.selectedPhoneId()),
      onClick: () => this.close()
    }
  ]);

  ngOnInit() {
    this.phones.set(this.#data.phones ?? []);

    if (this.isSinglePhone()) {
      this.setSelectedPhone(this.uniquePhone()?.id);
    }
  }

  close() {
    this.#modalManager.dismissMatModal(this.selectedPhoneId());
  }

  setSelectedPhone(phoneId: string | undefined) {
    this.selectedPhoneId.set(phoneId);
  }
}
